<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="document-icon"
    :width="size"
    :height="size"
    viewBox="0 0 50 50"
    fill="none">
    <path
      d="M45.8307 20.8307V31.2474C45.8307 41.6641 41.6641 45.8307 31.2474 45.8307H18.7474C8.33073 45.8307 4.16406 41.6641 4.16406 31.2474V18.7474C4.16406 8.33073 8.33073 4.16406 18.7474 4.16406H29.1641"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M45.8307 20.8307H37.4974C31.2474 20.8307 29.1641 18.7474 29.1641 12.4974V4.16406L45.8307 20.8307Z"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M14.5859 27.0859H27.0859"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M14.5859 35.4141H22.9193"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>

<script setup>
  defineProps({
    size: {
      type: Number,
      default: 50,
    },
    color: {
      type: String,
      default: 'var(--bs-primary)',
    },
  });
</script>

<style lang="scss" scoped>
  .document-icon path {
    stroke: var(--bs-primary);
  }
</style>
